export const safeJSONParse = <R extends any>(jsonString: string): R | undefined => {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.debug(error);
    return undefined;
  }
};
